import script from "./UserDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./UserDetailsPage.vue?vue&type=style&index=0&id=7fa78866&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fa78866"]])

export default __exports__